import differenceInDays from 'date-fns/difference_in_days'
import { parse } from 'date-fns'
import _find from 'lodash/find'
import _filter from 'lodash/filter'

const STATE_CALVING = 'calving'
const STATE_INSEMINATION = 'insemination'
const STATE_CULL = 'cull'
const STATE_ULTRASOUND = 'ultrasound'
const STATE_DRIED = 'dried'
const STATE_DEAD = 'dead'
const STATE_ABORTION = 'abortion'
const STATE_ABORTION_DEAD = 'abortion-dead'
const STATE_ABORTION_BUT = 'abortion-but'
const STATE_STILLBIRTH = 'stillbirth'
const STATE_STILLBIRTH_DEAD = 'stillbirth-dead'
const STATE_HOT = 'hot'
const STATE_PREGNANT = 'pregnant'
const STATE_STERILE = 'sterile'
const STATE_SOLD = 'sold'
const TYPE_COW = 'cow'
const TYPE_HEIFER = 'heifer'
const TYPE_CALF = 'calf'
const TYPE_BULL = 'bull'

export function getFecondityStatus(animal) {
    let fecondity = {}
    fecondity['state'] = 'error'
    let now = new Date().getTime() / 1000
    if (animal.states.length === 0) {
        if (animal.type === TYPE_HEIFER && now - animal.birthday > 31536000) {
            fecondity['state'] = 'inseminate'
            fecondity['for'] =
                differenceInDays(
                    parse(Date.now()),
                    new Date(animal.birthday * 1000)
                ) - 365
        } else {
            fecondity['state'] = 'nothing'
            fecondity['for'] = differenceInDays(
                parse(Date.now()),
                new Date(animal.birthday * 1000)
            )
        }
    } else {
        let lastUltrasound = _find(animal.states, ['state', 'ultrasound'])
        let lastInsemination = _find(animal.states, ['state', 'insemination'])
        let lastCalving = _find(animal.states, function(s) {
            return s.state === 'calving' || s.state === 'stillbirth' || s.state === 'abortion-but'
        })
        let diffInDaysLastState = differenceInDays(
            parse(Date.now()),
            new Date(animal.states[0].date * 1000)
        )
        if (animal.states[0].date !== null) {
            fecondity['for'] = diffInDaysLastState
        }
        if (animal.states[0].state === STATE_DRIED) {
            fecondity['state'] = 'dried'
        } else if (
            animal.states[0].state === STATE_CULL ||
            animal.states[0].state === STATE_STERILE ||
            animal.states[0].state === STATE_ABORTION_DEAD ||
            animal.states[0].state === STATE_STILLBIRTH_DEAD ||
            animal.states[0].state === STATE_SOLD
        ) {
            fecondity['state'] = 'culled'
        } else if (
            animal.states[0].state === STATE_ULTRASOUND &&
            lastInsemination !== undefined &&
            lastUltrasound.ultrasound !== undefined
        ) {
            let diffInDaysInsemination = differenceInDays(
                parse(Date.now()),
                new Date(lastInsemination.date * 1000)
            )
            if (diffInDaysInsemination > 210 && !!lastUltrasound.ultrasound.isSuccess) {
                fecondity['state'] = 'to-dry-up'
            } else if (lastUltrasound.ultrasound.isSuccess) {
                fecondity['state'] = 'inseminated'
            } else if (lastUltrasound.ultrasound.isVerif) {
                fecondity['state'] = 'ultrasound'
            } else {
                fecondity['state'] = 'non-inseminated'
            }
            fecondity['for'] = diffInDaysInsemination
        } else if (animal.states[0].state === STATE_ABORTION) {
            if ((animal.states[0].date - lastInsemination.date) >=
                24 * 60 * 60 * 210 ) {
                fecondity['state'] = 'calved'
            } else {
                fecondity['state'] = 'non-inseminated'
            }
        } else if (
            animal.states[0].state === STATE_CALVING ||
            animal.states[0].state === STATE_HOT ||
            animal.states[0].state === STATE_STILLBIRTH ||
            animal.states[0].state === STATE_ABORTION_BUT
        ) {
            let diffInDaysCalving = 0
            if (animal.states[0].state !== STATE_HOT) {
                diffInDaysCalving = differenceInDays(
                    parse(Date.now()),
                    new Date(animal.states[0].date * 1000)
                )
            } else if (lastCalving !== undefined) {
                diffInDaysCalving = differenceInDays(
                    parse(Date.now()),
                    new Date(lastCalving.date * 1000)
                )
            }

            // if(parseInt(animal.buckleNumber) === 30197) {
            //     console.log(animal.states[0].state)
            //     console.log(lastCalving)
            //     console.log(diffInDaysCalving)
            // }
            if (lastCalving !== undefined && diffInDaysCalving < 100) {
                fecondity['state'] = 'calved'
            } else if (lastCalving !== undefined && diffInDaysCalving >= 100) {
                fecondity['state'] = 'inseminate'
            }
            fecondity['for'] = diffInDaysCalving
        } else if (animal.states[0].state === STATE_INSEMINATION) {
            if (animal.states[0].state !== null && diffInDaysLastState < 35) {
                fecondity['state'] = 'monitor'
            } else if (
                (lastUltrasound !== undefined &&
                    lastUltrasound.date < animal.states[0].date) ||
                (animal.states[0].date !== null && diffInDaysLastState < 225)
            ) {
                fecondity['state'] = 'ultrasound'
            } else {
                if (animal.type === TYPE_HEIFER) {
                    fecondity['state'] = 'inseminated'
                } else {
                    fecondity['state'] = 'to-dry-up'
                }
            }
        }
        if (lastInsemination !== undefined) {
            animal['lastInsemination'] = lastInsemination.date
        }
        if (lastCalving !== undefined) {
            animal['lastCalving'] = lastCalving.date
        }
        if (lastUltrasound !== undefined) {
            animal['lastUltrasound'] = lastUltrasound.date
        }
    }
    if (fecondity['state'] === 'error') {
        console.log(JSON.stringify(animal))
    }
    animal = { ...animal, fecondity: fecondity }

    let lactation = []

    if(animal.states.length > 0) {
        lactation = _filter(animal.states, function(s) {
            return (
                s.state === 'calving' ||
                s.state === 'stillbirth' ||
                s.state === 'abortion-but' ||
                (s.state === 'abortion' &&
                    s.date - getInsemationBeforeAbortionDate(animal.states, s.date) >=
                    24 * 60 * 60 * 210)
            )
        })
    }

    animal = { ...animal, lactation: lactation.length }

    if (lactation.length > 1) {
        animal = { ...animal, beforeLastCalvingDate: lactation[1].date}
    } else if (lactation.length > 0) {
        animal = { ...animal, beforeLastCalvingDate: lactation[lactation.length - 1].date}
    }

    if(animal.milkResults.length > 0) {
        animal['lastMilkResult'] = animal.milkResults[0]['total']
    }

    return animal
}

function getInsemationBeforeAbortionDate(states, abortion) {
    let insemination = _filter(states, function(s) {
        return s.state === 'insemination' && s.date < abortion
    })

    return insemination[0].date
}